export default {
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~ESPANOL~': 'Spanish',
    '~PORTUGUES~': 'Portuguese',
    '~INGLES~': 'English',
    '~ITALIANO~': 'Italian',
    '~FRANCES~': 'French',
    '~IDIOMA~': 'Language',
    '~IDIOMA2~': 'Recognition Language',
    '~MENU~': 'Menu',
    '~USUARIOS~': 'Users',
    '~EDITAR~': 'Edit',
    '~DUPLICAR~': 'Duplicate',
    '~REFRESCAR~': 'Refresh',
    '~DESACTIVAR~': 'Deactivate',
    '~CARGANDO~': 'Loading',
    '~TOTALES~': 'totals',
    '~ACTIVAR~': 'Activate',
    '~AYUDA~': 'Help',
    '~AYUDA_ACTIVADA~': 'Help Active',
    '~AYUDA_DESACTIVADA~': 'Help Disabled',
    '~ACTIVADAS~': 'Help messages activated',
    '~DESACTIVADAS~': 'Help messages deactivated',
    '~CONFIRMAR_AYUDA~': 'Do you want to deactivate help messages?',
    '~ACEPTAR~': 'Accept',
    '~CONECTANDO~': 'Connecting',
    '~OPCIONES~': 'Options',
    '~ELIMINAR~': 'Delete',
    '~REMOVER~': 'Remove',
    '~CANCELAR~': 'Cancel',
    '~OMITIR~': 'Skip',
    '~EXPANDIR~': 'Expand',
    '~AGREGAR~': 'Add',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuration',
    '~HOY~': 'Today',
    '~SEMANA~': 'Week',
    '~PERSONALIZAR~': 'Personalize',
    '~ESTUDIANTE~': 'Estudent',
    '~MASCULINO~': 'Male',
    '~FEMENINO~': 'Female',
    '~VOLVER~': 'Back',
    '~SIGUIENTE~': 'Next',
    '~ANTERIOR~': 'Previous',
    '~GUARDAR~': 'Save',
    '~CERRAR~': 'Close',
    '~VALIDA_POR~': 'Valid for',
    '~FAMILIA~': 'Families',
    '~AUTORIZADO~': 'Authorized',
    '~AMIGOS~': 'Friends',
    '~PERSONAS~': 'People',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Vehicles',
    '~RETIRADAS_AUTORIZADO~': 'Withdrawals for Authorized',
    '~HORAS_RETIRADA~': 'Withdrawal Hours',
    '~CAMBIAR_CLAVE~': 'Change Password',
    '~EDITAR_PERFIL~': 'Edit Profile',
    '~HOME~': 'Home',
    '~COFIGURACION~': 'Configuration',
    '~MENU_PRINCIPAL~': 'Main Menu',
    '~FECHA~': 'Date',
    '~ALUMNOS~': 'Students',
    '~INFORMACION~': 'Information',
    '~FOTO_PERFIL~': 'Profile Picture',
    '~FOTO_VEHICULO~': 'Vehicle Picture',
    '~TOMAR_FOTO~': 'Take Photo',
    '~SUBIR_ARCHIVO~': 'Upload File',
    '~REGISTROS~': 'Register',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Details',
    '~BUSCADOR~': 'Search',
    '~SALIR~': 'Logout',
    '~TIPO~': 'Type',
    '~CONTINUAR~': 'Continue',
    '~CONFIRMAR~': 'Confirm',
    '~FINALIZAR~': 'Finalize',
    '~FINALIZADO~': 'The campaign is save',
    '~ALERTA~': 'Warning!',
    '~TITULO~': 'Title',
    '~VOZ~': 'Voice',
    '~NOTA~': 'Note',
    '~ACCION~': 'Action',
    '~ACCIONES~': 'Actions',
    '~FILAS~': 'Rows',
    '~DE~': 'of',
    '~A~': 'to',
    '~TEXTO~': 'Text',
    '~NUMERO~': 'Number',
    '~NEXT_STEP~': 'Next step',
    '~CONFIRMAR_BORRAR~': 'Are you sure you want to delete?',
    '~CONFIRMAR_REMOVER~': 'Are you sure you want to remove?',
    '~CONFIRMAR_PARAR~': 'Are you sure you want to stop the campaign?',
    '~MENSAJE_REFRESCAR~': 'Warning! The information in this table is not up to date, <br> please click on \'Refresh\'',
    relation: {
      '~NOMBRE~': 'Relation',
      options: {
        '~PADRE~': 'Parent',
        '~HIJO~': 'Child',
        '~RELATIVO~': 'Relative',
        '~EMPLEADO~': 'Employee'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'The email has been taken'
  },
  login: {
    '~TITULO~': 'Authentication',
    '~USUARIO~': 'User',
    '~CLAVE~': 'Password',
    '~NUEVA~': 'New Password',
    '~CORREO~': 'Email',
    '~ENTRAR~': 'Enter',
    '~OLVIDO~': 'Forgot your password?',
    '~RECORDARME~': 'Remember me',
    '~CONTACTO~': 'Contact Webmaster',
    '~RECUPERAR~': 'Password Recovery',
    '~MENSAJE~': 'We have sent an email with the recovery instructions',
    '~RECUPERACION_OK~': 'Your password has been successfully modified',
    '~ENVIAR~': 'Send',
    '~VOLVER~': 'Back to Login',
    '~RESETEAR~': 'Reset Password',
    '~VERIFICAR~': 'Validate Password',
    '~BIENVENIDO~': 'Wellcome to IP-COM System',
    '~NO_AUTORIZADO~': 'Error! email or password incorrect',
    '~NO_AUTENTICADO~': 'Sorry! You are not authenticated',
    '~EXITOSO~': 'Login Success',
    '~NO_USUARIO~': 'Error! This user is not found'
  },
  menu: {
    '~INICIO~': 'Home',
    '~TABLERO~': 'Dashboard',
    '~CAMPAGNA~': 'Campaigns',
    '~CAMPAGNA_ABIERTA~': 'Open Campaigns',
    '~BASE_DATOS~': 'Databases',
    '~ORGANIZACION~': 'Organizations',
    '~USUARIOS~': 'Users',
    '~REPORTES~': 'Reports',
    '~CONFIGURACION~': 'Settings'
  },
  campaign: {
    '~CAMPAGNA~': 'Campaign',
    '~IDIOMA~': 'Language',
    '~CAMPAGNA_ABIERTA~': 'Open Campaign Mode',
    '~EDITAR~': 'Edit Campaign',
    '~CERRAR~': 'Close Campaign',
    '~INSERTAR~': 'New Campaign',
    '~NOMBRE~': 'Campaign Name',
    '~SUSCRIPTORES~': 'Suscriber BD',
    '~PASO~': 'Step',
    '~ESTADO~': 'Status',
    '~ARBOL~': 'Navigation Tree',
    '~TRANSICION~': 'Transition',
    '~DIGITOS~': 'Digits',
    '~VARIABLE_NOMBRE~': 'Variable Name',
    '~TIEMPO~': 'Timeout',
    '~COMANDO_VOZ~': 'Voice',
    '~BASE_DATOS~': 'Database',
    '~LLAMADAS~': 'Concurrent Calls',
    '~INTERACCION~': 'Interactions',
    '~TASA_CONTACTO~': 'Contact Rate',
    '~PREFIJO~': 'Dial Prefix',
    '~REJECT_CODES~': 'ISDN Reject Codes',
    '~GRUPOS_RUTAS~': 'Route Group',
    '~IDENTIFICADOR~': 'Caller ID',
    '~ID_CLIENTE~': 'Client ID',
    '~TIEMPO_ESPERA~': 'Wait Time',
    '~TIEMPO_DIGITOS~': 'Digits Timeout',
    '~TIEMPO_REINTENTO~': 'Retry Time',
    '~MAQUINA_RESPUESTA~': 'Answer machine detection',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Automatically detects answering machines (AMD) and voicemail.',
    '~MAQUINA_COLGAR~': 'Answer Machine Detection Hangup',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Ends the call when voicemail is detected.',
    '~TITULO~': 'Title',
    '~TODAS~': 'All',
    '~TTS_MENSAJE~': 'TTS Message',
    '~TTS_MENSAJE2~': 'Previous TTS Message',
    '~PREFIJO_ARCHIVO~': 'File Prefix',
    '~MAXIMA_LONGITUD~': 'Max Length',
    '~REPETIR~': 'Repeat',
    '~FINAL~': '# At the end',
    '~IMPORTAR~': 'Import Contacts',
    '~IMPORTAR_CVS~': 'Import new records',
    '~IMPORTAR_DESC~': 'Now let\'s match the columns in your uploaded file to your Subscriber DB List',
    '~OMITIR_CABECERAS~': 'No Headers',
    '~NUEVA_COLUMNA~': 'New Column Name',
    '~INTENTOS_MAXIMOS~': 'Max Attempts',
    '~PROXIMO_REINTENTO~': 'NRA',
    '~INTENTOS_ALCANZADOS~': 'Maximum number of attempts reached',
    '~LLAMADAS_ALCANZADOS~': 'Maximum number of calls reached',
    '~INTENTOS_MAX~': 'Max Attempts',
    '~MAXIMO_ALCANZADO~': 'Maximum limit reached',
    '~CANALES_MAXIMOS~': 'Max Channels',
    '~ZONA_HORARIA~': 'Time Zone',
    '~COLGAR_NO_RESP~': 'Hang up if no answer',
    '~EXTENSION~': 'Extension',
    '~MINIMO_HORA~': 'Minimum Hour',
    '~MAXIMO_HORA~': 'Maximum Hour',
    '~SELECCIONAR_FECHA~': 'Select Date',
    '~FECHA_COMIENZO~': 'Start Date',
    '~FECHA_FINAL~': 'End Date',
    '~FECHA_ERROR~': 'Start date must be less than end date.',
    '~FECHA_CREACION~': 'Creation Date',
    '~ACTIVAS~': 'Active Campaigns',
    '~ULTIMAS~': 'Last Campaigns',
    '~BASES_MONITOREADAS~': 'Monitoried Bases',
    '~NUMEROS~': 'Numbers',
    '~EN_COLA~': 'Queued',
    '~MARCADO~': 'Dialed',
    '~CONTACTO~': 'Contact',
    '~VER~': 'View',
    '~ACTIVA~': 'Active / Max',
    '~SILENCIO~': 'Silence',
    '~REPETICIONES~': 'Number of Repetitions',
    '~AUDIO_INVALIDO~': 'Retry Audio',
    '~FRASE~': 'Phrase',
    '~VARIABLE~': 'Variable',
    '~FORMULA~': 'Formula',
    '~GENERACION_TTS~': 'TTS Generation',
    '~GENERAR_AUDIOS~': 'Synthetize Audios',
    '~PROBAR_AUDIO~': 'TTS Test',
    '~DESCARGAR_TTS~': 'Dowload TTS',
    '~ARCHIVAR~': 'Archive',
    '~OPERADOR~': 'Operator',
    '~AYUDA_VARCOMP~': 'Advanced code syntax',
    '~GUARDANDO~': 'Saving campaign',
    '~VOICES2_NOT_FOUND~': 'There are no voices for the selected language.',
    '~ACTIVE_CHANNELS~': 'Active Channels',
    subscriber: {
      '~BD_CREADA~': 'The database was created successfuly'
    },
    sayas: {
      '~NOMBRE~': 'Say as',
      options: {
        '~CARACTERES~': 'Characters',
        '~NUMERO~': 'Number',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Digits',
        '~FECHA~': 'Date'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'Caller ID',
      '~TELEFONO~': 'Phone number as Caller ID',
      '~CLIENTE~': 'Client ID as Caller ID',
      '~SUSCRIPTOR~': 'Subscriber ID as Caller ID'
    },
    '~NO_PAREJA~': 'unmatched column',
    '~NO_CAMPANA~': 'There are no campaigns registered',
    '~NO_ACTIVAS~': 'There are no active campaigns',
    '~SIN_RESULTADOS~': 'No campaigns found matching that criteria',
    '~BUSCAR_CAMPANA~': 'Search by name or ID...',
    '~NO_RESULTADO~': 'There was no search result',
    formula: {
      '~IGUAL~': 'Equal',
      '~MAYOR~': 'Greater than',
      '~MENOR~': 'Less than',
      '~MAYOR_IGUAL~': 'Greater or equal',
      '~MENOR_IGUAL~': 'Less than or equal',
      '~DISTINTO~': 'Distinct',
      '~REGULAR~': 'Regex',
      '~DEFAULT~': 'Default',
      '~DEFAULT_NAME~': 'Default Action'
    }
  },
  organization: {
    '~TITULO~': 'Organization',
    '~TITULO_PROGRAMA~': 'Software Title',
    '~LOGO_PERSONALIZADO~': 'Custom Logo',
    '~EDITAR~': 'Edit Organization',
    '~INSERTAR~': 'New Organization',
    '~NOMBRE~': 'Organization Name',
    '~TELEFONO~': 'Phone',
    '~NOMBRE_COMPLETO~': 'Fullname',
    '~SELECCIONADO~': 'Selected',
    '~NO_ORGANIZATION~': 'There are no organizations registered',
    '~IMAGEN_ERROR~': 'The size limit has been exceeded!',
    '~IMAGEN_MENSAJE~': 'Only .png and .jpg formats, and a maximum size of 5Mg',
    '~IMAGEN_TAMANO~': 'Sizes 264px/120px',
    '~PAÍS~': 'Country',
    '~CPS_MÁXIMO~': 'Maximum CPS',
    '~PROPIA~': 'Own',
    '~TELEFONÍA~': 'Telephony',
    '~Añadir_CPS~': 'Add CPS',
    '~CPS_MÁXIMO_ERROR~': 'The countrys CPS cannot exceed the parent organizations CPS in that country'
  },
  dialer: {
    '~NOMBRE~': 'Dialers',
    '~CAPACIDAD~': 'Capacity',
    '~ACTIVOS~': 'Actives',
    '~NO_MARCADORES~': 'There are no active dialer'
  },
  database: {
    '~TITULO~': 'Database',
    '~EDITAR~': 'Edit Database',
    '~INSERTAR~': 'New Database',
    '~NOMBRE~': 'Database Name',
    '~CREADA~': 'Created',
    '~ESTADO~': 'Status',
    '~COLUMNAS~': 'Columns',
    '~REGISTROS_DE~': 'records of',
    '~SUSCRIPTORES~': 'Subs.',
    '~BORRAR_SUBS~': 'Delete subscribers that are not in this new file',
    '~EDITAR_SUBS~': 'Update variables in existing subscribers',
    '~SUSCRIPTORES_FULL~': 'Subscribers',
    '~NO_DATABASE~': 'There are no databases registered',
    '~NO_RESULTADO~': 'No search result was obtained',
    '~VARIABLE_PHONE~': 'There must be a field with name "phone" to continue',
    '~VALIDATE_NUMBER~': 'Validate numbering',
    '~COUNTRY~': 'Country',
    '~ONLY_CALL_TO_NUMBERS~': 'Dial for numbers only',
    '~DONWLOAD_INVALID_NUMBERS~': 'Do you want to download the report of invalid numbers from the database?'
  },
  report: {
    '~TITULO~': 'Reports',
    '~EDITAR~': 'Edit Report',
    '~INSERTAR~': 'New Report',
    '~CREADA~': 'Created',
    '~ESTADO~': 'Status',
    '~INFORME_RESUMIDO~': 'Summary Report',
    '~INFORME_BASE~': 'Base Summary',
    '~INFORME_DURACION~': 'Summary Duration',
    '~ENCUESTA~': 'Survey',
    '~CONTESTADA~': 'Answered',
    '~RESPUESTAS~': 'Answers',
    '~PROMEDIO_ENCUESTA~': 'Survey Ratio',
    '~OCUPADO~': 'Busy',
    '~SEGUNDOS~': 'Seconds',
    '~SEGUNDOS_MIN~': 'Sec',
    '~MINUTOS~': 'Minutes',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Invalid Number',
    '~NO_REPICO~': 'No Ring',
    '~NO_CONTESTO~': 'No Answer',
    '~PROMEDIO_CONTESTO~': 'Contact Ratio',
    '~DETALLES_INTENTOS~': 'Details by Attemps',
    '~INTENTOS~': 'Attemps',
    '~DISPOSICION~': 'Disposition',
    '~NUMEROS~': 'Numbers',
    '~CODIGO_ISDN~': 'ISDN Code',
    '~PRIMERO~': 'Firts',
    '~ULTIMO~': 'Last',
    '~NO_REPORTE~': 'There are no report registered',
    '~NO_DATA~': 'You have not enough data',
    '~DESCARGAR~': 'Download Report',

    '~SUMAR_REPORTES~': 'Add Reports',
    '~REPORTE_COMPLETO~': 'Full Report',
    '~SUMADAS~': 'Added',
    '~TITULO_SELECCION~': 'Select the campaigns you want to add to the report'
  },
  users: {
    '~EDITAR~': 'Edit User',
    '~INSERTAR~': 'New User',
    '~NO_USUARIOS~': 'There are no users registered',
    '~AGREGAR~': 'Add User',
    '~TITULO~': 'User List',
    '~NOMBRE~': 'Firstname',
    '~APELLIDO~': 'Lastname',
    '~CORREO~': 'Email',
    '~CLAVE~': 'Password',
    '~TELEFONO~': 'Phone',
    '~CELULAR~': 'Mobile',
    '~POSICION~': 'Position',
    '~ID_TARJETA~': 'Card',
    '~ACTIVO~': 'Active',
    '~INACTIVO~': 'Inactive',
    '~ROL~': 'Roles',
    '~ORGANIZACIONES~': 'Organizations',
    '~ROLES_TODAS~': 'Update roles in all orgs',
    '~ROLES_ACTUAL~': 'Update roles only for',
    '~ACTUALIZAR_ORGS~': 'Actualizar organizaciones a la cual pertenece el usuario',
    '~BUSCAR~': 'Search...',
    '~ETIQUETA_SELECCION~': 'Press enter to select'
  },
  file: {
    '~NOMBRE~': 'Name',
    '~NOMBRE_AMIGABLE~': 'Friendly Name',
    '~SUBIR~': 'Upload File',
    '~ACEPTABLE~': 'Aceptable file type: CSV',
    '~PERMANENTE~': 'Permanent',
    '~DESCARGAR~': 'Download Report'
  },
  audio: {
    '~AGREGAR~': 'Insert Audio',
    '~BORRAR~': 'Delete',
    '~SELECCION~': 'Select Audio',
    '~REPRODUCIR~': 'Play',
    '~REPRODUCIENDO~': 'Playing',
    '~DETENER~': 'Pause',
    '~PAUSAR~': 'Pause',
    '~CONTINUAR~': 'Resume',
    '~VOZ~': 'Voice',
    '~NOMBRE~': 'Audio Name',
    '~ARCHIVO~': 'Audio File',
    '~NO_AUDIO~': 'There were no results',
    '~GUARDANDO~': 'Saving audios'
  },
  action: {
    '~NOMBRE~': 'Action',
    options: {
      '~COLGAR~': 'Hangup',
      '~RETORNAR~': 'Return',
      '~EMPEZAR~': 'Begin',
      '~REPETIR~': 'Repeat'
    }
  },
  step: {
    '~NOMBRE~': 'Step',
    '~GUARDAR~': 'Save Step',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Playback',
      '~RECORD~': 'Record',
      '~RECORD_DIGITS~': 'Record Digits',
      '~TRANSFERIR~': 'Transfer',
      '~ASR~': 'Asr',
      '~VARIABLE_WEB~': 'Web Variable',
      '~COLGAR~': 'Hangup',
      '~RETORNAR~': 'Return',
      '~EMPEZAR~': 'Begin',
      '~REPETIR~': 'Repeat',
      '~DELAY~': 'Delay'
    }
  },
  transition: {
    '~NOMBRE~': 'Transition',
    options: {
      '~DIGITOS~': 'Digits',
      '~SIGUIENTE~': 'Next',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'None'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~': '<strong>Wellcome to IP-COM System</strong><br /><br />This is de Admin area please take your time for this short tour. <br /><br />With this virtual tour by clicking on. <strong>Next</strong>',
      '~MENU~': 'In this sidebar you will find the main navigation menu, necessary to access any area of the application.',
      '~USER_CARD~': 'User profile information',
      '~SALIR~': 'Logout button.',
      '~LISTA_ORG~': 'Organization selector list, use it to swich the current organization.',
      '~MENU_TABLERO~': '<strong>Dashboard</strong><br /><br />Displays the active campaigns in real time, the last campaigns processed, the affiliate database, and the TTS audios generated in each campaign.',
      '~MENU_ORGANIZACION~': '<strong> Organization </ strong> <br /> <br /> Shows client organizations and allows you to register new organizations, edit them and delete them.',
      '~MENU_BASEDATOS~': '<strong> Databases </ strong> <br /> <br /> View, manage and generate subscriber databases used when creating a campaign.',
      '~MENU_CAMPANA~': '<strong> Campaigns </ strong> <br /> <br /> It allows to see, create, manage and configure campaigns. Monitors the exact time and date of generation of each campaign. Review and download reports.',
      '~MENU_USERS~': '<strong> Users </ strong> <br /> <br /> Registered and authorized users to create, monitor, edit and configure campaigns, databases, etc., according to the role and level of access granted.',
      '~BARRA~': 'Top bar, contains the current navigation page and some tools.',
      '~IDIOMA~': 'Language selection.',
      '~MENU_IDIOMA~': 'Language Options.',
      '~AYUDA~': 'Activate or Deactivate visual aids.',
      '~ACTIVAS~': 'In this panel here, active campaigns are reflected in real time.',
      '~CAMPANAS~': 'In this panel here, the last campaigns created or edited are listed.',
      '~SUBSCRIBERS~': 'In this panel here, the latest subscriber databases created or edited are listed',
      '~TTS_AUDIOS~': 'In this panel here, you will find the progress of the audio generation of the campaigns',
      organization: {
        '~INTRO~': 'Overview of the organizations registered in IPCOM with their data configured according to the company; In addition to the options to add new ones and edit or delete existing ones',
        '~BUSCADOR~': 'Write the name of the organization you want to search',
        '~INSERTAR~': 'Registers new organizations in the system.',
        '~TABLA~': 'Each row shows the ID of the organization in the system and the legal name. You can also edit or delete already registered organizations.',
        '~ACCIONES~': 'Actions for the management of the respective organization.',
        '~EDITAR~': 'Edit data of the organization respectively.',
        '~ELIMINAR~': 'Remove organization from the system after confirmation.'
      },
      subscriber: {
        '~INTRO~': 'Select a database already loaded in the system or add new databases for your campaign.<br /><br />You can edit or delete the database that you require, if necessary.',
        '~BUSCADOR~': 'Enter the name of the database you want to search.',
        '~INSERTAR~': 'Load new databases to the system.',
        '~TABLA~': 'Each row reflects the name of the database, creation date, number of subscribers and columns used in the campaign.',
        '~ACCIONES~': 'Actions for the management of the respective databases.',
        '~EDITAR~': 'Edit the configuration of this database.',
        '~ELIMINAR~': 'Delete this database after confirming.',
        uploadform: {
          '~FORMULARIO~': '<strong>File Form</strong><br /><br /> The CSV (comma-separated values) file is used to exchange data in the form of a spreadsheet column. <br /> <br /> Add the name and upload the CSV file that you have saved to your device.',
          '~ARCHIVO~': 'Click to select the CSV file from your device.',
          '~CANCELAR~': 'Cancel and return to the previous screen.',
          '~ENVIAR~': 'Send form and go to the next step.'
        },
        import: {
          '~FORMULARIO~': '<strong>Import Contacts</strong><br /><br /> Before importing the database, configure the names of the variables contained in the previously loaded CSV file.',
          '~GRUPO~': 'Each box represents a column of the CSV file previously loaded.',
          '~COLUMNAS~': 'This box shows the name of the column, part of its content and configuration options to edit or omit the variable.',
          '~EDITAR~': 'Click if you want to change the name of the column.',
          '~OMITIR~': 'Click if you want to Ignore this column from the database.',
          '~CABECERAS~': 'Allows you to discard the first row or header of the CSV file previously loaded.',
          '~CANCELAR~': 'Cancel and go to the previous menu.',
          '~GUARDAR~': 'Save all changes and generate the new Subscriber Database.'
        }
      },
      campaign: {
        '~INTRO~': 'Review, manage and configure old and new campaigns. <br /><br />Monitors the exact time and date of generation of the campaigns. Review and download reports.',
        '~BUSCADOR~': 'Enter the name of the campaign you want to search.',
        '~INSERTAR~': 'Set up a new campaign from scratch.',
        '~TABLA~': 'Each row presents the name of a campaign in the system, its status, date and time of creation and actions for its configuration.',
        '~ACCIONES~': 'Actions for the management of the respective campaign.',
        '~EDITAR~': 'Edit all data and campaign settings.',
        '~COPIAR~': 'Create new campaigns by cloning the content of this campaign.',
        '~REPORTES~': 'Explore data, statistics and relevant campaign information.',
        '~DESCARGAS~': 'Download the campaign report in a CSV file.',
        '~ARCHIVAR~': 'Archive the campaign report.',
        '~CPS_MÁXIMO_ERROR~': 'The value assigned to the CPS exceeds the maximum established within the organization. Maximum CPS: {cps}.',
        steps: {
          '~COFIGURACION~': '<strong>Configuration</strong><br /><br />Write correctly the requested data in each of the configuration registration boxes.<br /><br />This data determines the value of the variables in the campaign to be added.',
          '~BASEDATOS~': 'Select a database already loaded in the system or add new databases for your campaign.<br /><br />You can edit or delete the database that you require, if necessary.',
          '~DIAPLAN~': 'Create the Campaign you want through a system of steps. <br /> <br /> The Dialplan is organized by steps and transitions.',
          '~ENVIAR~': 'Before sending, verify that the data, files, audios and requests made have been correctly loaded.',
          '~NAVEGADOR~': 'Navigate through this bar (breadcrumbs), to find a way to return to the previous step.',
          '~SELECTOR~': 'Select from this list the type of step that allows you to correctly configure the Dialplan.',
          '~ACTUAL~': 'In this area the current step is configured. <br /> <br /> Fill in the data correctly according to the type of step selected for the Dialplan.',
          '~TRANSICION~': 'The transition allows you to connect new steps in the campaign based on the configuration you need.',
          '~ARBOL~': 'It allows you to know the steps used during the configuration each campaign. <br /> <br /> You can select any step you want to edit',
          '~PASO_ACTUAL~': 'The highlighted in blue means the step that is currently being edited.',
          '~PANEL_CONFIG~': 'Summary of the configuration data in step 1.',
          '~PANEL_DATABASE~': 'Information on the subscriber database that will be used in the campaign.',
          '~PANEL_DIALPLAN~': 'Tree of steps showing the previously configured dial plan.',
          '~ENVIAR_FINAL~': 'Click here to Send, once you agree with the information shown here.',
          '~SINTETIZAR~': 'If there are audios that have to be generated within your tagging plan, you must first click here to proceed to generate them.'
        }
      },
      user: {
        '~INTRO~': 'Know the main data of registered users authorized by your organization to manage and configure the system.',
        '~BUSCADOR~': 'Search a user registered in the application by name.',
        '~INSERTAR~': 'Register a new user in the system.',
        '~TABLA~': 'Each row shows the user\'s first and last names, phone number, email, role in the system, card number and activity status.',
        '~ACCIONES~': 'Actions for the management of the respective user.',
        '~ACIVAR~': 'Activate and deactivate user.',
        '~EDITAR~': 'Edit data from the user respectively.',
        '~ELIMINAR~': 'Remove user from the system after confirmation.'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js